var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataReady)?_c('ModalRoot',{class:{ 'modal-dialog--small': _vm.config.modalSize === 'small' },attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"closeByClickingOutside":true},on:{"close":_vm.close}},[_c('Content',{attrs:{"config":_vm.config},on:{"title":_vm.titleUpdated,"subtitle":_vm.subtitleUpdated}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49e07fe0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 1073
// module chunks = 1